import { createFileRoute } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/Layout";
import { PageHero } from "@/components/sections/PageHero";
import { Services } from "@/components/sections/Services";
import { WhyFaq } from "@/components/sections/WhyFaq";
import { Appointment } from "@/components/sections/Appointment";
import { loadDashboardSeo, mergeSeoHead } from "@/lib/dashboard-seo";

export const Route = createFileRoute("/services")({
  loader: () => loadDashboardSeo("/services"),
  head: ({ loaderData }) => mergeSeoHead(loaderData, ({
    meta: [
      { title: "Services, Bayly Dental Clinic" },
      { name: "description", content: "Explore our full range of dental services: general, cosmetic, restorative, Invisalign, family and emergency care." },
      { property: "og:title", content: "Services, Bayly Dental Clinic" },
      { property: "og:description", content: "Comprehensive dental services in Pickering." },
          { property: "og:url", content: "https://baylydentalclinic.com/services" },
],
    links: [
      { rel: "canonical", href: "https://baylydentalclinic.com/services" },
    ],
  })),
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <SiteLayout>
      <PageHero eyebrow="Our Services" title="Care for every smile, at every stage." subtitle="From routine cleanings to advanced cosmetic dentistry, we've got you covered." />
      <Services />
      <WhyFaq />
      <Appointment />
    </SiteLayout>
  );
}